export default __webpack_public_path__ + "static/media/message.1c23a1cb.svg";